import React, { useState } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import AddFieldDrawer from '~/pages/cp/subscribers/customfields/incAddCustomField'

export default function SmsCampaignField({ campaign, customFields = [], updateCampaign, countSubs }) {
    const [addingField, setAddingField] = useState(false)

    const availableFields = customFields.filter(f => f.fieldType === 'TELNO').map(f => ({ label: f.fieldDesc, value: f.id }))

    const addField = () => {
        setAddingField(true)
    }

    const finishedAddingField = (newField) => {
        customFields.push(newField)
        campaign.options.smsField = newField.id
        updateCampaign()
        countSubs()
        setAddingField(false)
    }

    const set = (e) => {
        campaign.options.smsField = e.currentTarget.value
        countSubs()
        updateCampaign()
    }

    return (
        <Paper style={{ padding: 24 }}>
            <h6 className=" mar-b20">Phone Number Field</h6>
            {!availableFields.length && <div className="text-warning text-med mar-b20">You don't have any Phone Number fields configured.</div>}
            {!availableFields.length && <Button text="Add New Field" onClick={addField} className="button-sml" />}
            {Boolean(availableFields.length) && <div>
                <Select data={availableFields} value={campaign.options.smsField} onChange={set} placeholder="Select Phone Number Field" />
            </div>}

            <Drawer isOpen={addingField} persist={true} standalone={true} width={300} showClose={true} close={() => setAddingField(false)}>
                <AddFieldDrawer getCustomFields={finishedAddingField} standalone={true} forceType="TELNO" />
            </Drawer>
        </Paper>
    )
}